import { Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BreakpointsService, BIPPERZ_BREAKPOINTS } from '../services/breakpoint.service';

@Component({
  selector: 'app-mobile-notification',
  templateUrl: './app-mobile-notification.component.html',
  standalone: true,
  styleUrls: ['./app-mobile-notification.component.scss'],
  imports: [NgIf, TranslateModule],
})
export class MobileNotificationComponent {
  private breakpointsService = inject(BreakpointsService);

  showBanner = false;

  readonly googlePlayUrl =
    'https://play.google.com/store/apps/details?id=com.app.bipperz' +
    '&utm_source=bipperz_web&utm_medium=mobile_banner&utm_campaign=app_download&utm_content=google_play';

  readonly appStoreUrl =
    'https://apps.apple.com/de/app/bipperz/id6760047548' +
    '?utm_source=bipperz_web&utm_medium=mobile_banner&utm_campaign=app_download&utm_content=app_store';

  constructor() {
    this.breakpointsService
      .observe([BIPPERZ_BREAKPOINTS.s, BIPPERZ_BREAKPOINTS.m_down])
      .subscribe((result) => {
        this.showBanner = result['s'] || result['m_down'];
      });
  }

  dismiss(): void {
    this.showBanner = false;
  }
}